import { render, staticRenderFns } from "./message-abstract-file.vue?vue&type=template&id=04573203&scoped=true"
import script from "./message-abstract-file.vue?vue&type=script&lang=ts"
export * from "./message-abstract-file.vue?vue&type=script&lang=ts"
import style0 from "./message-abstract-file.vue?vue&type=style&index=0&id=04573203&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04573203",
  null
  
)

export default component.exports